// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vlXg","type":"styles_type__2uHJ8","choices":"styles_choices__3dcS7"};